<template>
  <div>
    <div class="leixin">
      <div class="containers">
        <div class="type-tabs">
          <!-- 渲染类型选项卡 -->
          <div v-for="(item, index) in typeList" :key="index"
            :class="['type-item', { 'type-active': typeIndex === item.ID }]" @click="switchType(item.ID)">
            {{ item.TITLE }}
          </div>
        </div>

        <!-- 筛选区域 -->
        <div class="shaixuan">
          <!-- 搜索框 -->
          <div style="width: 450px;" class="filter-item">
            <el-input placeholder="请输入公告名称、项目编号、竞价名称" v-model="query.keyword" clearable></el-input>
          </div>

          <div class="xian"></div>

          <!-- 项目状态选择框 -->
          <div class="filter-item">
            <el-select clearable @change="select_change" v-model="query.bid_status" placeholder="项目状态">
              <el-option label="即将开始" value="0" />
              <el-option label="竞价中" value="1" />
              <el-option label="已结束" value="2" />
              <el-option label="已终止" value="3" />
            </el-select>
          </div>

          <div class="xian"></div>

          <!-- 起拍价选择 -->
          <div class="jiage">
            <span>起拍价</span>
          </div>

          <div class="filter-item">
            <el-input clearable v-model="query.starting_price_start" placeholder="￥" class="price-input" />
            <span class="price-separator">-</span>
            <el-input clearable v-model="query.starting_price_end" placeholder="￥" class="price-input" />
          </div>

          <el-button type="info" @click="handleSearch">搜索</el-button>
        </div>

        <!-- 项目列表内容 -->
        <div class="neirong">
          <div class="project-list">
            <!-- 渲染项目列表 -->
            <div class="project-item" v-for="(item, index) in projectList" :key="index"
              @click="handleProjectClick(item)">
              <div class="project-info">
                <div class="project-title">
                  <div class="poleng">
                    <div class="center_box">
                      <!-- 项目标题 -->
                      <span style="font-size: 24px;">
                        {{ item.BIDDING_TITLE }}
                      </span>
                    </div>
                    <div>
                      <span style="margin-right: 20px;color: #999;">发布日期：{{ item.PUBLISH_TIME_TXT }}</span>
                    </div>
                  </div>
                </div>
                <div class="jieshao">
                  项目公告: {{ item.TITLE }}
                </div>
                <div class="box">
                  <div class="flex1">
                    <div class="project-details">
                      <div class="detail-item">
                        <span class="label">项目编号：</span>
                        <span>{{ item.PROJECT_NUM }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="label">竞价开始时间：</span>
                        <span>{{ item.BIDDING_START_TIME_TXT }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex2">
                    <div class="detail-item">
                      <div class="label2">
                        <span class="label">项目分类：</span>
                        <div class="iconx">{{ item.TYPE_NAME }}</div>
                      </div>
                    </div>
                    <div class="detail-item">
                      <span class="label">报名截止时间：</span>
                      <span>{{ item.APPLY_END_TIME_TXT }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 项目图片展示 -->
              <div class="userimg">
                <img :src="handle_img(item.STATUS)" alt="" style="width: 220px" />
              </div>
            </div>
            <!-- 如果没有项目，显示暂无数据 -->
            <el-empty v-if="projectList.length == 0" description="暂无数据..."></el-empty>

            <!-- 加载动画 -->
            <Loading :loading="loading" color="#c31424" background="rgba(0, 0, 0, 0.3)" />
          </div>

          <!-- 分页 -->
          <div class="boxc">
            <el-pagination @current-change="current_change" :current-page="query.page" :total="total"
              :page-size="query.limit" class="custom-pagination" background layout="prev, pager, next">
            </el-pagination>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: true, // 加载状态
      query: {
        keyword: '', // 搜索关键字
        type_id: '', // 项目类型ID
        page: 1, // 当前页
        limit: 10, // 每页显示数量
        bid_status: '', // 项目状态
        starting_price_start: '', // 起拍价区间起始
        starting_price_end: '', // 起拍价区间结束
      },
      total: 0,
      typeList: [], // 项目类型列表
      typeIndex: 0, // 当前选中的类型
      projectList: [], // 项目列表
    };
  },
  created() {
    this.get_project_type(); // 获取项目类型
  },
  methods: {
    /**
    * @description 分页页码改变事件处理
    * @param {number} page 当前页码
    */
    current_change(page) {
      // 更新查询参数中的页码
      this.query.page = page;
      // 重新获取列表数据
      this.get_list();
    },
    select_change(e) {

    },
    // 项目类型选择变化时触发
    switchType(index) {
      this.typeIndex = index;
      this.query.type_id = this.typeIndex;
      this.loading = true;
      this.get_list(); // 切换项目类型后获取列表数据
    },

    // 获取项目列表数据
    async get_list() {
      const res = await this.$http.get('/api/project/get_bidding', { params: this.query });
      if (res.data.code == 200) {
        this.projectList = res.data.data.data;
        this.total = res.data.data.total; // 更新总条数
        this.loading = false; // 获取完成后关闭加载动画
      } else {
        this.$message.error(res.data.msg); // 显示错误信息
        this.projectList = []; // 清空数据
        this.total = 0; // 重置总数
      }
    },

    // 获取项目类型
    async get_project_type() {
      const res = await this.$http.post('/api/common/get_project_type', {});
      let obj = {
        ID: '',
        TITLE: "全部"
      }
      this.typeList = res.data.data;
      this.typeList.unshift(obj); // 添加单个元素

      this.typeIndex = this.typeList[0].ID; // 默认选中第一个类型
      this.query.type_id = this.typeIndex;
      this.get_list(); // 默认获取该类型的项目列表
    },

    // 搜索按钮点击事件
    handleSearch() {
      this.loading = true;
      this.get_list(); // 根据当前筛选条件获取项目列表
    },

    // 项目点击事件
    handleProjectClick(item) {
      let obj = {
        id: item.ID,
        bidding: 1
      };
      this.$emit('Bding', obj); // 向父组件发送选中的项目数据
    },

    // 根据项目状态返回对应的图片
    handle_img(status) {
      const images = [
        require('../assets/status0.png'),
        require('../assets/status1.png'),
        require('../assets/status2.png'),
        require('../assets/status3.png'),
        require('../assets/status4.png'),
        require('../assets/status5.png')
      ];

      return images[status] || ''; // 返回对应的图片
    }
  },
};
</script>


<style lang="scss" scoped>
// 变量定义
$primary-color: #c31424;
$border-color: #eee;
$text-color: #666;
$bg-color: #f5f5f5;
$container-width: 1200px;

.custom-pagination ::v-deep .el-pager .number {
  border-radius: 50% !important;
}

.containers {
  width: $container-width;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;

  .type-tabs {
    margin-top: 10px;
    // height: 75.2px;
    // overflow-x: scroll;
    display: flex;
    // background-color: #f4f4f4;
  }
}

.type {
  &-tabs {
    width: 100%;
    display: flex;
    border-radius: 4px 4px 0 0;
  }

  &-item {
    // min-width: 250px;
    width: 20%;
    height: 60px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $bg-color;
  }

  &-active {
    background-image: url("../assets/R22.png");
    background-size: 100% 100%;
    color: white;
    // background-color: #fff;
  }

  &-content {
    width: 100%;
    margin-top: 20px;
  }

  &-table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 12px;
      text-align: left;
      border-bottom: 1px solid $border-color;
    }

    th {
      background: $bg-color;
      font-weight: normal;
    }

    tr:hover {
      background: #f9f9f9;
    }
  }
}

.shaixuan {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /* 允许换行 */
  gap: 10px;
  /* 控制间距 */
  gap: 20px;
  padding: 15px;
  background-color: #f4f5f9;
  border-radius: 4px;
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
}

.filter-item {}

.jiage {
  color: #a6a6a6;
}

.xian {
  width: 2px;
  height: 40px;
  background-color: #edeef1;
}

.price-input {
  width: 100px;
}

.price-separator {
  margin: 0 8px;
}

.neirong {
  width: 100%;
  margin-top: 20px;

  .userimg {
    position: absolute;
    right: -5px;
    top: 63px;
  }
}

.project-list {
  min-height: 600px;
  position: relative;
  overflow-y: auto;
  width: 100%;

  .project-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: #fff;
    margin-bottom: 10px;
    border-radius: 4px;
    border: 1px solid #edeef1;
    position: relative;
    cursor: pointer;
    width: 99%;
    box-sizing: border-box;

    &:hover {
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }
  }
}

.project-info {
  flex: 1;
}

.project-title {
  font-size: 16px;
  margin-bottom: 15px;

  .poleng {
    display: flex;
    justify-content: space-between;
    align-items: center;

  }

  .status-tag {
    padding: 0px 8px;
    border-radius: 1px;
    font-size: 12px;
    margin-right: 10px;
    color: #fff;
    height: 24px;
    line-height: 24px;
    display: inline-block;
    box-sizing: border-box;

    &.published {
      background: #8e44ad;
    }

    &.bidding {
      background: #3498db;
    }

    &.upcoming {
      background: #f1c40f;
    }

    &.ended {
      background: #2ecc71;
    }
  }
}

.jieshao {
  color: #999999;
  line-height: 14px;
  margin-bottom: 10px;
  font-size: 14px;
}

.flex1 {
  display: flex;
}

.flex2 {
  margin-left: 120px;
}

.box {
  display: flex;
  color: #666;
  font-size: 14px;
}

.detail-item {
  line-height: 30px;
  font-size: 17px;

}

.label2 {
  display: flex;
}

.iconx {
  background-color: #ededed;
  margin-right: 10px;
  padding: 0 5px 0 5px;
  color: #333333;
  font-size: 13px;
}

.project-details {
  color: #666;
  font-size: 17px;

  .label {
    color: #999;
  }
}

.project-status {
  padding: 10px 20px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;

  &.published {
    background: linear-gradient(to right, #8e44ad, #9b59b6);
  }

  &.bidding {
    background: linear-gradient(to right, #3498db, #2980b9);
  }

  &.upcoming {
    background: linear-gradient(to right, #f1c40f, #f39c12);
  }

  &.ended {
    background: linear-gradient(to right, #2ecc71, #27ae60);
  }
}

.boxc {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>